<ng-template #vbTooltipContent>
	<section [ngClass]="styles.contentWrapper">
		<p>{{ text }}</p>
		<p [hidden]="!linkUrl">{{ 'Tooltip_LearnMore' | translate }} <a href="{{ linkUrl }}" [ngClass]="styles.contentLink">{{ 'UI_HereLink' | translate }}</a></p>
	</section>
</ng-template>

<span class="glyphicons" [ngClass]="[styles.tooltip, iconName]" [tooltip]="vbTooltipContent" [attr.aria-label]="text" #popup="bs-tooltip" container="body" tabindex="0" [placement]="placement" [triggers]="tooltipTrigger">
</span>
